/**Where the data comes from in modalselect */
export enum SourceType {
    Lookup = 'lookup',
    API = 'api',
    Local = 'local'
}
